module.exports = __webpack_public_path__ + "static/media/food-1.52d12cc4.png";